import React from 'react';
import Grid from '@material-ui/core/Grid';
import styled, { css, keyframes } from 'styled-components';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Button, { ButtonVariations } from '../SolvPatternLibrary/Button';
import { colors } from '../../constants/colors';
import localizedStr, { EN_US, SupportedLocale } from '../../core/util/localizedStr';
import { capitalize } from '../../core/util/string';
import FileUpload from '../SolvPatternLibrary/FileUpload';

const BaseCard = styled(Card)`
  width: 328px;
  height: 192px;
  border-radius: 12px;
  position: relative;
  box-shadow: none;
`;

const StyledCard = styled(BaseCard)`
  text-align: center;
  overflow: visible;
  margin-top: 15px;
  cursor: pointer;
  box-shadow: none;
  ${(props) => css`
    border: 1px
      ${// @ts-expect-error ts-migrate(2339) FIXME: Property 'sc' does not exist on type 'CardProps & ... Remove this comment to see the full error message
      props.sc.borderStyle}
      ${// @ts-expect-error ts-migrate(2339) FIXME: Property 'sc' does not exist on type 'CardProps & ... Remove this comment to see the full error message
      props.sc.borderColor || colors.black};
    opacity: ${// @ts-expect-error ts-migrate(2339) FIXME: Property 'sc' does not exist on type 'CardProps & ... Remove this comment to see the full error message
    props.sc.disabled ? 0.5 : 1};
  `};
`;

const StyledCardPicture = styled(BaseCard)`
  background: ${colors.white}
    url(${(props) =>
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'sc' does not exist on type 'CardProps & ... Remove this comment to see the full error message
      props.sc.imgData})
    no-repeat center;
  background-size: cover;
  overflow: hidden;
  -webkit-mask-image: -webkit-radial-gradient(white, black);
`;

const scanKeyframe = keyframes`
  from { transform: translateX(-328px); }
  to { transform: translateX(0); }
`;

const scanAnimation = css`
  animation: ${scanKeyframe} 2s linear infinite alternate;
`;

const StyledScanOverlay = styled(BaseCard)`
  border-radius: 0;
  background-color: ${colors.blueJayWay};
  opacity: 0.5;
  transform: translateX(-328px);
  ${({
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sc' does not exist on type 'ThemedStyled... Remove this comment to see the full error message
    sc,
  }) => sc.selfAnimate && scanAnimation}
`;

const StyledScanHead = styled.div`
  height: 210px;
  z-index: 1;
  box-shadow: 0 0 2px ${colors.greyHounds};
  width: 5px;
  position: absolute;
  transform: translateX(-328px);
  right: -2.5px;
  top: -9px;
  background-color: ${colors.white};
  margin: auto 0;
  ${({
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sc' does not exist on type 'Pick<Detaile... Remove this comment to see the full error message
    sc,
  }) => sc.selfAnimate && scanAnimation}
`;

const StyledCardHeader = styled(Typography)`
  color: ${colors.fadeToBlack};
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.38px;
  line-height: 27px;
`;

const StyledCardBody = styled(Typography)`
  color: ${colors.blueMonday};
  font-size: 14px;
  letter-spacing: -0.2px;
  line-height: 20px;
`;

const UploadButton = styled(Button)`
  width: 80% !important;
  height: 45px;
  padding: 0;
  margin-top: 20px;
`;

const StyledInput = styled(FileUpload)`
  width: 328px;
  height: 192px;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.01;
  border: none;
  z-index: 10;
`;

const HintContainer = styled.div`
  text-align: left;
  margin-left: 20px;
`;

const Container = styled.div`
  margin: 0 auto;
  display: inline-flex;
  align-items: center;
  width: 90%;
  margin-top: 20px;
`;

const CardPlaceholder = styled.img`
  height: 58px;
  width: 43px;
`;

const VIEW_PICTURE = 0;
const VIEW_PLACEHOLDER = 1;
const VIEW_BLANK = 2;

type Props = {
  cardImage?: string;
  children?: any;
  onClick?: (...args: any[]) => any;
  showPlaceholder?: boolean;
  disabled?: boolean;
  scanStarted?: boolean;
  scanCompleted?: boolean;
  handleFileChange: (...args: any[]) => any;
  parentControlAnimation?: boolean;
  animationClassName?: string;
  buttonStyle?: string;
  placeholderCopy?: string;
  placeholderImage?: string;
  locale?: SupportedLocale;
};

const InsuranceCard = (props: Props) => {
  const {
    cardImage,
    showPlaceholder,
    scanStarted,
    scanCompleted,
    onClick,
    children,
    disabled,
    handleFileChange,
    parentControlAnimation,
    animationClassName = '',
    buttonStyle = ButtonVariations.pinkPrimary,
    placeholderCopy,
    placeholderImage,
    locale = EN_US,
  } = props;

  let view;
  if (cardImage) {
    view = VIEW_PICTURE;
  } else if (showPlaceholder) {
    view = VIEW_PLACEHOLDER;
  } else {
    view = VIEW_BLANK;
  }

  const showScanAnimation = scanStarted && !scanCompleted;

  switch (view) {
    case VIEW_PLACEHOLDER:
      return (
        <StyledCard
          elevation={0}
          onClick={onClick}
          // @ts-expect-error ts-migrate(2769) FIXME: Property 'sc' does not exist on type '(IntrinsicAt... Remove this comment to see the full error message
          sc={{ borderStyle: 'dashed', borderColor: colors.black }}
        >
          <StyledInput
            // @ts-expect-error FIXME: Property 'accept' does not exist... Remove this comment to see the full error message
            accept={'image/*'}
            data-hj-suppress
            onChange={handleFileChange}
            type="file"
          />

          <Container>
            <CardPlaceholder src={placeholderImage} />

            <HintContainer>
              <StyledCardHeader>{children}</StyledCardHeader>

              <StyledCardBody>{placeholderCopy}</StyledCardBody>
            </HintContainer>
          </Container>

          <Grid item xs={12}>
            <UploadButton variation={buttonStyle}>
              {capitalize(localizedStr[locale].TAKE_A_PHOTO, { locale })}
            </UploadButton>
          </Grid>
        </StyledCard>
      );
    case VIEW_PICTURE:
      return (
        // @ts-expect-error ts-migrate(2769) FIXME: Property 'sc' does not exist on type '(IntrinsicAt... Remove this comment to see the full error message
        <StyledCard data-hj-suppress sc={{ borderColor: 'none', disabled }}>
          {showScanAnimation && (
            <StyledScanHead
              className={animationClassName}
              // @ts-expect-error ts-migrate(2769) FIXME: Property 'sc' does not exist on type 'IntrinsicAtt... Remove this comment to see the full error message
              sc={{ selfAnimate: !parentControlAnimation }}
            />
          )}
          {/* @ts-expect-error ts-migrate(2769) FIXME: Property 'sc' does not exist on type '(IntrinsicAt... Remove this comment to see the full error message */}
          <StyledCardPicture data-hj-suppress sc={{ imgData: cardImage }}>
            {showScanAnimation && (
              <StyledScanOverlay
                className={animationClassName}
                // @ts-expect-error ts-migrate(2769) FIXME: Property 'sc' does not exist on type '(IntrinsicAt... Remove this comment to see the full error message
                sc={{ selfAnimate: !parentControlAnimation }}
              />
            )}
          </StyledCardPicture>
        </StyledCard>
      );
    default:
    case VIEW_BLANK:
      // @ts-expect-error ts-migrate(2769) FIXME: Property 'sc' does not exist on type '(IntrinsicAt... Remove this comment to see the full error message
      return <StyledCard sc={{ borderStyle: 'solid', borderColor: colors.borderLine }} />;
  }
};

export default InsuranceCard;
